export enum DrawMode {
  DRAWING = 1,
  ERASING,
  EYE_DROP,
  FLOOD_FILL,
}
